/** Shop cost is stored as a decimal rate (e.g. 0.05 = 5%). */
export function formatCostRate(raw: string | number | undefined | null): string {
  const n = raw === undefined || raw === null ? 0 : Number(raw);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(n);
}
